import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://vmc-backend-vt2w.onrender.com/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

// Attach Access Token from localStorage before each request
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * Fetch the current consumer's dashboard data:
 * - user profile (users + profile_consumer)
 * - stats (totalReviews, avgRating, totalHelpful, uniqueBusinesses)
 * - recentReviews (last 5)
 */
export const fetchConsumerDashboard = async () => {
  const response = await apiClient.get('/consumer/me');
  return response.data.data;
};

/**
 * Update consumer profile fields (name, phone, bio, gender, location, etc.)
 */
export const updateConsumerProfile = async (profileData) => {
  const response = await apiClient.put('/consumer/profile', profileData);
  return response.data;
};

/**
 * Change consumer password.
 * Requires currentPassword and newPassword.
 */
export const changeConsumerPassword = async ({ currentPassword, newPassword }) => {
  const response = await apiClient.post('/consumer/change-password', { currentPassword, newPassword });
  return response.data;
};

/**
 * Fetch all reviews written by the current consumer with optional filters.
 * Params: { status, sort_by, order, limit, offset }
 */
export const fetchConsumerReviews = async (params = {}) => {
  const response = await apiClient.get('/consumer/reviews', { params });
  return response.data;
};

/**
 * Update a consumer's own review.
 * Body: { title, content, rating, experience_date }
 */
export const updateConsumerReview = async (reviewId, data) => {
  const response = await apiClient.put(`/consumer/reviews/${reviewId}`, data);
  return response.data;
};

/**
 * Delete a consumer's own review.
 */
export const deleteConsumerReview = async (reviewId) => {
  const response = await apiClient.delete(`/consumer/reviews/${reviewId}`);
  return response.data;
};
